export enum Priority {
  NONE = 0, // default for all popups
  LOW = 1,
  MEDIUM = 2,
  HIGH = 3, // HIGH+ is allowed when _blockPopups === true
  VERY_HIGH = 4,
  IMMEDIATE = 5, // should only be used for user interactions!
}
